import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BusinessFeedbackTable = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const response = await axios.get('https://citi-mobile-app.onrender.com/businessmanager/feedbacks');
        setFeedbacks(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching feedbacks:', error);
        setLoading(false);
      }
    };

    fetchFeedbacks();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-3 sm:ml-60 bg-white rounded-md mt-20">
      <h1 className="text-lg sm:text-2xl mb-4">Feedback Table</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg">
          <thead className="bg-gray-200 text-gray-600 text-xs sm:text-sm uppercase">
            <tr>
              <th className="py-3 px-2 sm:px-6 text-[#1E1E1E]">No</th>
              <th className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">Agent</th>
              <th className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">Customer Name</th>
              <th className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">Visit Date</th>
              <th className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">Visit Outcome</th>
              <th className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold hidden md:table-cell">Comment</th> {/* Hidden on mobile */}
              <th className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold hidden md:table-cell">Strike Rate</th> {/* Hidden on mobile */}
            </tr>
          </thead>
          <tbody className="text-gray-700 text-xs sm:text-sm">
            {feedbacks.map((feedback, index) => (
              <tr key={index} className="border-b border-gray-200 hover:bg-gray-100">
                <td className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">{index + 1}</td>
                <td className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">{feedback.email}</td>
                <td className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">{feedback.customerName}</td>
                <td className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">{feedback.visitDate}</td>
                <td className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold">{feedback.visitOutcome}</td>
                <td className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold hidden md:table-cell">{feedback.comment}</td> {/* Hidden on mobile */}
                <td className="py-3 px-2 sm:px-6 text-[#1E1E1E] font-bold hidden md:table-cell">{feedback.strikeRate}</td> {/* Hidden on mobile */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BusinessFeedbackTable;
